import { render, staticRenderFns } from "./TaxInvoiceForm.vue?vue&type=template&id=68b81c01&scoped=true"
import script from "./TaxInvoiceForm.vue?vue&type=script&lang=js"
export * from "./TaxInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoiceForm.vue?vue&type=style&index=0&id=68b81c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b81c01",
  null
  
)

export default component.exports